<template>
  <div :class="'header__cont'">
    <div :class="'header'">
      <a :href="'https://www.jakarto.com/'" :class="'header__link'"><jakarto-full-logo :color="iconColor"></jakarto-full-logo></a>
      <slot name="content"></slot>
      <logout-icon :color="iconColor" :class="'header__logout'" @click="logout()"></logout-icon>
    </div>
  </div>
</template>

<script setup>
import JakartoFullLogo from '@/components/icons/jakarto-full-logo.vue'
import LogoutIcon from '@/components/icons/IconLogout.vue'

const props = defineProps({
  logout: Function
})

const iconColor = getComputedStyle(document.documentElement).getPropertyValue('--white')

</script>

<style lang="scss" scoped>
.header__cont {
  position: absolute;
  top: 10px;
  right: 5px;
}

.header {
  position: relative;
  z-index: 100;
  height: 40px;
  width: 148px;
  border-radius: 16px;
  padding: 0px 15px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  background: var(--primary);

  box-shadow: var(--panel-shadow);
}

.header__link {
  height: 21px;
}

.header__logout {
  height: 21px;
  width: 21px;
  margin-left: 15px;

  cursor: pointer;
}
</style>